import { render, staticRenderFns } from "./SubscriptionsForm.vue?vue&type=template&id=3dd90b54"
import script from "./SubscriptionsForm.vue?vue&type=script&lang=js"
export * from "./SubscriptionsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports